module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "Abb"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BEF")]), _vm._v(" – British Expeditionary Force")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CIGS")]), _vm._v(" – Chief of the Imperial General Staff")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DCIGS")]), _vm._v(" – Deputy Chief of the Imperial General Staff")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DDMI(I)")]), _vm._v(" – Deputy Director, Military Intelligence (Intelligence)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DDMI(O)")]), _vm._v(" – Deputy Director, Military Intelligence (Operations)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DDMI(R)")]), _vm._v(" – Deputy Director, Military Intelligence (Research)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D/M")]), _vm._v(" – Unofficial title briefly replacing GS(R) in April 1939")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DMI")]), _vm._v(" – Director of Military Intelligence")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DMT")]), _vm._v(" – Directorate of Military Training")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DSR")]), _vm._v(" – Directorate of Scientific Research")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GC&CS")]), _vm._v(" – Government Code and Cypher School")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GHQ")]), _vm._v(" – General Headquarters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("G(R)")]), _vm._v(" – formal name of MI(R) Middle East")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GSO")]), _vm._v(" – General Staff Officer (in Grades 1–3)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GS(R)")]), _vm._v(" – General Services (Research). The research unit from which MI(R) was formed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HDS")]), _vm._v(" – Home Defence Scheme of Section D")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISPB")]), _vm._v(" – Inter-Services Project Board")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISSB")]), _vm._v(" – Inter-Services Security Board")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IWM")]), _vm._v(" – Imperial War Museum")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LDV")]), _vm._v(" – Local Defence Volunteers (original name of the Home Guard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LRDG")]), _vm._v(" – Long Range Desert Group")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MD1")]), _vm._v(" – The designation of MI(R)c after its transfer to the Ministry of Defence")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI1(a)")]), _vm._v(" – Distribution of reports and intelligence records")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI1(c)")]), _vm._v(" – The designation for SIS within the War Office")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI1(R)")]), _vm._v(" – Official title of what is usually known as MI(R) or MIR in June 1939 to formally replace GS(R)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI3")]), _vm._v(" – Geographical information")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI5")]), _vm._v(" – Security Service")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI6")]), _vm._v(" – Popular name of SIS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI7")]), _vm._v(" – Propaganda and Censorship")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI9")]), _vm._v(" – Escape and Evasion organization")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI10")]), _vm._v(" – Weapons and Technical Intelligence")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI11")]), _vm._v(" – Field Security")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MIL")]), _vm._v(" – Liaison, Arms traffic and Law")])]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MIR")]), _vm._v(" – Alternative form of MI(R) in contemporary documents from June 1940")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI(R)")]), _vm._v(" – Military Intelligence Research department from June 1940")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI(R)a")]), _vm._v(" – Coordination of Projects and Services section of MI(R)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI(R)b")]), _vm._v(" – Special Operations and Political Action section of MI(R)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI(R)c")]), _vm._v(" – Technical section of MI(R), later transferred to the Ministry of Defence as MD1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MO9")]), _vm._v(" – Military Operations department created to manage the Commandos")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NID")]), _vm._v(" – Naval Intelligence Department")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NWEF")]), _vm._v(" – North Western Expeditionary Force (Norway campaign)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OCTU")]), _vm._v(" – Officer Cadet Training Unit")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OER")]), _vm._v(" – Officers Emergency Reserve")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PUS")]), _vm._v(" – Permanent Under-Secretary of State")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RARO")]), _vm._v(" – Regular Army Reserve of Officers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SAS")]), _vm._v(" – Special Air Service")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Section D")]), _vm._v(" – Sabotage section of SIS, which worked closely with MI(R)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIME")]), _vm._v(" – Security Intelligence, Middle East")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIS")]), _vm._v(" – Secret Intelligence Service, popularly known as MI6")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SOE")]), _vm._v(" – Special Operations Executive")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SPD")]), _vm._v(" – German Social Democratic Party (Sozialdemokratische Partei)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STS")]), _vm._v(" – Special Training School (of SOE)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TA")]), _vm._v(" – Territorial Army")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TARO")]), _vm._v(" – Territorial Army Reserve of Officers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TNA")]), _vm._v(" – The National Archives")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VCIGS")]), _vm._v(" – Vice Chief of the Imperial General Staff")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aef33552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Abbreviations.vue
// module id = 75
// module chunks = 0